module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingContent),
      expression: "loadingContent"
    }]
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "config": _vm.config,
      "itens": _vm.formDataItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "col-md-12 btn-login"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-floppy-o",
      "type": "success",
      "click": _vm.salvar,
      "loading": _vm.loadingSave,
      "value": "Salvar"
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7647d68e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/credenciada/meu-cadastro/index.vue
// module id = 1539
// module chunks = 45